import type {
	FinalFieldsPatchModel,
	HTTPValidationError,
	OptimizationModel,
	ProductsUpdateModel,
	ValidateProductDiffsFileForm,
	ValidateProductDiffsResponse,
} from '@/shared/generated'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export function useValidateProductDiffFileMutation(
	options?: UseMutationOptions<
		ValidateProductDiffsResponse,
		AxiosError<HTTPValidationError>,
		ValidateProductDiffsFileForm
	>
) {
	return useMutation<
		ValidateProductDiffsResponse,
		AxiosError<HTTPValidationError>,
		ValidateProductDiffsFileForm
	>({
		mutationFn: (payload) => client.optimizations.validateProductDiff(payload),
		...(options || {}),
	})
}

export function useUpdateProductsModelFieldsByFiltersMutation(
	optimizationGroupId: string,
	options?: UseMutationOptions<
		OptimizationModel | null,
		AxiosError<HTTPValidationError>,
		ProductsUpdateModel
	>
) {
	return useMutation<
		OptimizationModel | null,
		AxiosError<HTTPValidationError>,
		ProductsUpdateModel
	>({
		mutationFn: (body) =>
			client.optimizations.optimizationProductDiffsFilters(
				{ optimizationGroupId },
				body
			),
		...(options || {}),
	})
}
export function useUpdateProductsFinalFieldsByFiltersMutation(
	optimizationGroupId: string,
	options?: UseMutationOptions<
		OptimizationModel | null,
		AxiosError<HTTPValidationError>,
		FinalFieldsPatchModel
	>
) {
	return useMutation<
		OptimizationModel | null,
		AxiosError<HTTPValidationError>,
		FinalFieldsPatchModel
	>({
		mutationFn: (body) =>
			client.optimizations.optimizationFinalFieldsFilters(
				{ optimizationGroupId },
				body
			),
		...(options || {}),
	})
}
